VjsAdmin.MarketingPlatformsEdit = (function () {
    const init = function () {
        initEvents();
    };

    const initEvents = function () {};

    return {
        init,
    };
}());
